import React from 'react'
import Navigate from '../components/shared/Navigate';
import useAuth from '../hooks/useAuth';
import LoginPage from '../pages/LoginPage';

const LoginRoute = () => {
    const {auth} = useAuth();

    return (
        !auth?.accessToken ? <LoginPage/> : <Navigate to={'/'} replace />
    );
};

export default LoginRoute;